// extracted by mini-css-extract-plugin
export var bottomBorder = "sectionHeader-module--bottomBorder--d0dbe";
export var buttonContainer = "sectionHeader-module--buttonContainer--870a2";
export var buttonContainerInline = "sectionHeader-module--buttonContainerInline--fbc28";
export var centeredContent = "sectionHeader-module--centeredContent--8d84b";
export var charcoal = "sectionHeader-module--charcoal--084e7";
export var cotton = "sectionHeader-module--cotton--13856";
export var dark = "sectionHeader-module--dark--d5b94";
export var eyebrow = "sectionHeader-module--eyebrow--f097e";
export var headline = "sectionHeader-module--headline--b44bd";
export var inset = "sectionHeader-module--inset--ee129";
export var light = "sectionHeader-module--light--e3970";
export var oneColumn = "sectionHeader-module--oneColumn--a3d16";
export var sectionHeader = "sectionHeader-module--sectionHeader--88cf0";
export var subtext = "sectionHeader-module--subtext--33a63";
export var topBorder = "sectionHeader-module--topBorder--818e2";
export var white = "sectionHeader-module--white--e7f98";